import gql from 'graphql-tag';
import { StoreCityItemFragment } from './StoreCityItemFragment.mainEndpoint';

export const CartMainFragment = gql`
  fragment CartMainFragment on CartModel {
    id
    cookieId
    totalWithDeliveryPrice
    needReceipt
    addressConfirmedByUser
    warning
    lessContainers
    containerPrice
    is_menu
    canOrderBeCreated
    storeCityItem {
      ...StoreCityItemFragment
    }
    dadata {
      id
      isValidForExpress
      geoLat
      geoLon
      cityType
      city
      settlementType
      settlement
      streetType
      street
      houseType
      house
      blockType
      block
    }
    fio
    email
    flat
    phone
    comment
    delivery_id
    store_id
    lastCartStoreId
    deliveryDate
    deliveryIntervalEnd
    deliveryIntervalId
    deliveryIntervalStart
    interval_start_minutes
    interval_end_minutes
    deliveryCost
    people {
      bill {
        billAmount
      }
    }
    peopleAddress {
      id
      region_city_id
      isValidForExpress
      dadata {
        geoLat
        geoLon
      }
      storeItem {
        id
        address
        name
        shop {
          price
          identify
          type
        }
      }
    }
    services {
      id
      service {
        id
        title
        multiple
        shortDescription
        priceWithSubscription
        subscriptionPeriod
        subscription_period
        price
        maxQuantityInOrder
      }
      subscription
      amount
      price
      total
    }
    gifts {
      id
      title
      price
      oldPrice
      maxPurchase
      mainImage
      cartItemId
      mainRootRubric {
        id
        title
        shortTitle
        short_title
        identify
      }
      nearestDelivery {
        value
      }
      isAvailableForPurchase
    }
    items {
      id
      nearestDeliveryAmount
      catalogItem {
        isExpressDeliveryAval
        id
        bonus_payment_enabled
        isMenu
        isNotForSaleBarMenu
        is_not_for_sale
      }
      product {
        war_id
        weight_of_goods
        measureItem {
          weight
          symbol
        }
        symbolPriceField
        symbolPriceField2
        postcardAllowed
        isPostponed
        isFavorite
        digital
        id
        isMenu
        is_not_for_sale
        forbid_discount
        superPrice
        title
        package
        price
        oldPrice
        maxPurchase
        mainImage
        weightOfGoods
        weightOfPacking
        priceBlockWeightPrice
        discounPriceField
        discounPriceField2
        mainRootRubric {
          id
          title
          shortTitle
          short_title
          identify
        }
        nearestDelivery {
          value
        }
        gds_count
        isAvailableForPurchase
      }
      amount
      purchasePrice
      specialPrice
      discount
      freeOfCharge
      postcards {
        id
        cartItem {
          id
          product {
            id
          }
        }
        sender
        text
      }
    }
    promoCodes {
      id
      promoCode {
        canBeCancelled
        id
        promoCodeType {
          id
          identify
          title
        }
        giftItem {
          id
          title
          mainImage
        }
        product {
          id
        }
        title
        text
        code
        value
        canBeCancelled
      }
      actual
    }
    billPayed
    total
    subtotal
    minAllowableTotal
    possibleBonus {
      value
      maxValue
      priceDifference
      loyaltyProgram {
        id
        comment
        freeDelivery
        productsAsGifts {
          id
          title
          __typename
        }
        servicesAsGifts {
          id
          title
          hasDescription
          __typename
        }
        minOrderPrice
        __typename
      }
      nextLoyaltyLevels {
        id
        comment
        freeDelivery
        minOrderPrice
        productsAsGifts {
          id
          title
          __typename
        }
        servicesAsGifts {
          id
          title
          hasDescription
          __typename
        }
      }
      __typename
    }
    payment {
      id
      identify
      title
      minPrice
      maxPrice
      mainImage
    }
    testDrives {
      descriptionForCart
      id
      mainImage
      titleForCart
      produtImages
      peopleStatus {
        id
        title
      }
    }
    cartTestDrive {
      id
      product {
        id
        title
      }
      testDrive {
        id
      }
    }
    cartLoyaltyProgram {
      id
      quantity
      freeDelivery
      loyaltyProgram {
        id
        title
        minOrderPrice
        maxQuantityInOrder
        bonusPercentage
        freeDelivery
        comment
        productsAsGifts {
          id
          title
          price
          oldPrice
          maxPurchase
          mainImage
          weightOfGoods
          status {
            id
          }
          mainRootRubric {
            id
            title
            shortTitle
            short_title
            identify
          }
          nearestDelivery {
            value
          }
          isAvailableForPurchase
        }
        servicesAsGifts {
          id
          title
          multiple
          shortDescription
          priceWithSubscription
          subscriptionPeriod
          subscription_period
          price
          maxQuantityInOrder
        }
      }
      product {
        id
        title
        price
        oldPrice
        maxPurchase
        mainImage
        weightOfGoods
        mainRootRubric {
          id
          title
          shortTitle
          short_title
          identify
        }
        nearestDelivery {
          value
        }
        isAvailableForPurchase
      }
      service {
        id
        title
        multiple
        shortDescription
        priceWithSubscription
        subscriptionPeriod
        subscription_period
        price
        maxQuantityInOrder
      }
    }
  }
  ${StoreCityItemFragment}
`;
